import React, { useState } from 'react'
import classNames from 'classnames'
import StickyWrapper, {
  IProps as StickyWrapperProps,
} from 'Components/new/scroll-sticky/sticky-wrapper'
import { useResponsive } from 'Components/hooks/use-responsive'
import useSideNavStatus from 'Components/hooks/use-side-nav-status'
interface IProps {
  children: StickyWrapperProps['children']
  className?: string
}

const StickyBottom = ({ children, className }: IProps) => {
  const [state, setState] = useState({
    isFixed: false,
    duration: 0,
  })
  const { xl } = useResponsive()
  const sideNavStatus = useSideNavStatus()

  const left =
    (xl && sideNavStatus === 'lg-off') || sideNavStatus === 'on' ? 166 : 94

  return (
    <React.Fragment>
      <StickyWrapper
        className={className}
        outerClassName={(isFixed) =>
          classNames({
            'tw-fixed tw-z-10 tw-w-full tw-bottom-0 tw-inset-x-0 tw-m-auto tw-transform tw-translate-x-0 tw-h-70 ':
              isFixed,
          })
        }
        outerStyle={(isFixed) => (isFixed ? { width: '100%' } : undefined)}
        innerClassName={(isFixed) =>
          classNames({
            'tw-absolute tw-inset-y-0 article-sticky-bottom-inner ': isFixed,
          })
        }
        state={state}
        setState={setState}
        canListenScroll={({ isIntersecting }) => !isIntersecting}
        isCurrentFixed={({ isIntersecting, isScrollUp }) =>
          !isIntersecting && isScrollUp
        }
      >
        {children}
        {/* left: calc(4% + ${left}px); */}
      </StickyWrapper>
      <style jsx global>
        {`
          .article-sticky-bottom-inner {
            width: calc(100% - ${left}px);
            padding: 0 4%;
            left: ${left}px;
          }
        `}
      </style>
    </React.Fragment>
  )
}

export default StickyBottom
